import { DateFactoryService } from '../services/date-factory.service';

/**
 * @returns {DateFactoryService} date service
 */
export function dateFactory(): DateFactoryService {
  return new DateFactoryService();
}
